<template>
  <div class="panel-body">
    <v-layout row wrap>
      <v-flex lg8 md8 sm12 xs12>
        <v-card flat>
          <v-container>
            <v-layout row wrap>
              <v-flex lg8 md2>
                <h2 class="m-t-none earth-color">{{ singleFacility.name }}</h2>
                <v-chip :depressed="true"
                        color="primary"
                        v-if="singleFacility.status === 5"
                        text-color="white">Active</v-chip>
                <v-chip :depressed="true"
                        color="danger"
                        v-if="singleFacility.status === 7">
                  Off
                </v-chip>
                <v-container>
                  <p>
                    <b>Quantity : {{ singleFacility.quantity }}</b>
                  </p>
                  <p>
                    <b>Max Guests : {{ singleFacility.maximum_guests }}</b>
                  </p>
                  <p>
                    <b>Department Code : {{ singleFacility.analysis_code }}</b>
                  </p>
                  <p>
                    <b>Income Account Code : {{ singleFacility.code }}</b>
                  </p>
                  <p>
                    <b>
                      Outlet Code :
                      {{ singleFacility.outlet_analysis_code }}
                    </b>
                  </p>
                  <p v-if="singleFacility.vat === true"><b>VAT:</b> Set</p>
                  <p v-else><b>VAT:</b> Not Set</p>
                  <p v-if="singleFacility.catering_levy === true">
                    <b>Catering Levy:</b> Set
                  </p>
                  <p v-else><b>Catering Levy:</b> Not Set</p>
                  <p v-if="singleFacility.has_extras === true">
                    <b>Has Extras:</b> Yes
                  </p>
                  <p v-else><b>Has Extras:</b> No</p>
                  <p v-if="singleFacility.allocation">
                    <b>Allocation:</b> {{ singleFacility.allocation[0] }}
                  </p>

                  <p v-if="singleFacility.has_revenue_split">
                    <b>Has Revenue Split:</b> Yes
                  </p>

                </v-container>
              </v-flex>
            </v-layout>
            <br />
            <div class="small m-t-xs">
              <p>
                Added on
                <b>{{ formated_date_time(singleFacility.created_at) }}</b> by
                <b>{{ singleFacility.user }}</b>
              </p>
              <p v-if="
                  singleFacility.update_status === 'true' ||
                  singleFacility.update_status === true
                ">
                Last updated on
                <b>
                  {{
                  formated_date_time(singleFacility.updated_by.created_at)
                  }}
                </b>
                by <b>{{ singleFacility.updated_by.updated_by }}</b>
              </p>
            </div>
            <br />
            <h3 class="earth-color">DETAILS :</h3>
            <span v-html="singleFacility.description"> </span>
            <div class="m-t-md">
              <canvas id="lineOptions" height="60"></canvas>
            </div>
          </v-container>
        </v-card>
        <v-container>
          <price-surge></price-surge>
          <br />
          <facility-availability></facility-availability>
          <br />
          <br />
          <pricing-parameters v-if="singleFacility.facility_type_id === 'External Accommodation'"></pricing-parameters>
          <br />
          <facility-pricing></facility-pricing>
          <br />
          <extra-pricing v-if="singleFacility.facility_type_id === 'External Accommodation'"></extra-pricing>
          <br />
          <facility-commission v-if="singleFacility.facility_type_id === 'External Accommodation'"></facility-commission>
          <br />
          <special-pricing v-if="
              singleFacility.facility_type_id === 'Accomodation' &&
              singleFacility.accomodation_type_id === 'Pelican'
            "></special-pricing>
          <br />
          <facility-split-revenue v-if="singleFacility.has_revenue_split"></facility-split-revenue>
          <br />

          <facility-contacts></facility-contacts>
          <br />
          <facility-discount v-if="singleFacility.facility_type_id != 'External Accommodation'"></facility-discount>
        </v-container>
      </v-flex>
      <v-flex lg4 md4 sm12 xs12>
        <v-container>
          <v-card flat>
            <v-container>
              <v-card-title>
                <h4 class="earth-color">
                  Accommodation Calendar at a Glance
                </h4>
              </v-card-title>
              <v-layout row wrap>
                <v-flex lg5 md5 sm12 xs12 offset-lg2 offset-md2>
                  <small class="stat-label">Today</small>
                  <h4>{{ facilitySchedule.today_count }}</h4>
                </v-flex>
                <v-flex lg5 md5 sm12 xs12>
                  <small class="stat-label">Tomorrow</small>
                  <h4>{{ facilitySchedule.tomorrow_count }}</h4>
                </v-flex>
                <v-flex lg5 md5 sm12 xs12 offset-lg2 offset-md2>
                  <small class="stat-label">This Week</small>
                  <h4>{{ facilitySchedule.this_week_count }}</h4>
                </v-flex>
                <v-flex lg5 md5 sm12 xs12>
                  <small class="stat-label">Next Week</small>
                  <h4>{{ facilitySchedule.next_week_count }}</h4>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <br />
          <v-card flat>
            <v-container>
              <facility-images></facility-images>
            </v-container>
          </v-card>
          <br />
          <v-card flat>
            <v-container>
              <v-btn :depressed="true"
                     color="warning"
                     block
                     @click="editFacility()">
                <i class="fa fa-pencil"></i>EDIT ACCOMMODATION/CAMPING
              </v-btn>
            </v-container>
          </v-card>
          <br />
          <v-card flat>
            <v-container>
              <v-btn :depressed="true"
                     color="error"
                     block
                     v-on:click="makeInactive(singleFacility.public_id)">Make Inactive</v-btn>
            </v-container>
          </v-card>
          <br />
          <v-card flat>
            <v-container>
              <v-btn :depressed="true"
                     block
                     @click="delete_status = delete_status - 1"
                     v-if="delete_status > 0"
                     color="warning">Delete Inventory ({{ delete_status }})</v-btn>
              <v-btn :depressed="true"
                     block
                     @click="deleteInventory()"
                     v-if="delete_status === 0"
                     color="error">Delete Inventory</v-btn>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import FacilityDiscount from "./FacilityDiscount";
  import FacilityImages from "./FacilityImages";
  import FacilityPricing from "./FacilityPricing";
  import FacilityContacts from "./FacilityContacts";
  import SpecialPricing from "./SpecialPricing";
  import FacilityAvailability from "./FacilityAvailability";
  import PriceSurge from "./PriceSurge";
  import FacilityPricingParameters from "./FacilityPricingParameters";
  import FacilityExtraPricing from "./FacilityExtraPricing";
  import FacilityCommission from "./FacilityCommission";
  import FacilitySplitRevenue from "./FacilitySplitRevenue";
  export default {
    data() {
      return {
        delete_status: 3,
        update: false,
      };
    },
    components: {
      SpecialPricing,
      FacilityContacts,
      FacilityPricing,
      FacilityImages,
      FacilityDiscount,
      FacilityAvailability,
      PriceSurge,
      "pricing-parameters": FacilityPricingParameters,
      "extra-pricing": FacilityExtraPricing,
      "facility-commission": FacilityCommission,
      "facility-split-revenue": FacilitySplitRevenue,
    },
    created() {
      this.$store.dispatch("get_all_revenue_split", this.$route.params.facility_id);
      this.$store.dispatch("get_facility", this.$route.params.facility_id);
      this.$store.dispatch("get_facility_images", this.$route.params.facility_id);
      this.$store.dispatch("get_facility_schedule", {
        facility_id: this.$route.params.facility_id,
      });

    },
    methods: {
      deleteInventory: function () {
        var data = {
          facility_id: this.$route.params.facility_id,
          deleted_by: localStorage.getItem("lkjhgfdsa"),
        };
        this.$store.dispatch("delete_facility", data);
      },
      editFacility: function () {
        this.$router.push({
          name: "EditFacility",
          params: {
            facility_id: this.$route.params.facility_id,
          },
        });
      },
      makeInactive: function (publicId) {
        var data = {
          public_id: publicId,
          session_id: localStorage.getItem("lkjhgfdsa"),
        };
        this.$store.dispatch("make_facility_inactive", data);
      },
    },
  };
</script>

<style></style>
